package fr.frux.core.designsystem.components

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.VisualTransformation

@Composable
fun FruxTextField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    modifier: Modifier = Modifier,
    isError: Boolean = false,
    supportingText: String? = null,
    keyboardOptions: KeyboardOptions = KeyboardOptions.Default,
    visualTransformation: VisualTransformation = VisualTransformation.None,
    singleLine: Boolean = true,
    trailingIcon: (@Composable () -> Unit)? = null,
    keyboardActions: KeyboardActions = KeyboardActions.Default,
    enabled: Boolean = true,
    placeholder: String? = null,
    /**
     * Borne de saisie (#294) : au-delà, la frappe et le collage sont tronqués, et un compteur
     * « n/max » apparaît en texte d'appui à l'approche de la limite (dernier dixième), pour que
     * la borne se découvre à l'écran et pas par une erreur serveur. Un [supportingText] explicite
     * (message d'erreur) garde la priorité sur le compteur.
     */
    maxLength: Int? = null,
) {
    val counter =
        maxLength?.takeIf { value.length >= it - it / 10 }?.let { "${value.length}/$it" }
    OutlinedTextField(
        value = value,
        onValueChange = { onValueChange(if (maxLength != null) it.take(maxLength) else it) },
        modifier = modifier.fillMaxWidth(),
        label = { Text(label) },
        placeholder = placeholder?.let { { Text(it) } },
        isError = isError,
        supportingText =
            (supportingText ?: counter)?.let {
                {
                    Text(
                        text = it,
                        color =
                            if (isError) {
                                MaterialTheme.colorScheme.error
                            } else {
                                MaterialTheme.colorScheme.onSurfaceVariant
                            },
                    )
                }
            },
        keyboardOptions = keyboardOptions,
        visualTransformation = visualTransformation,
        singleLine = singleLine,
        trailingIcon = trailingIcon,
        keyboardActions = keyboardActions,
        enabled = enabled,
        shape = MaterialTheme.shapes.medium,
        colors = OutlinedTextFieldDefaults.colors(),
    )
}
